import {
  ApiPostMixPuzzleQuestionParams,
  apiPostMixPuzzleQuestionPath,
  ApiPostMixPuzzleQuestionResponse,
} from "apiRoutes/apiQuestionRoutes";
import { getMixPuzzlePoints } from "shared/games/getPoints";
import { GameAnswerMixPuzzle } from "shared/games/types/GameAnswers";
import { GameQuestionMixPuzzle } from "shared/games/types/GameQuestions";
import api, { isSuccess } from "util/api";
import createGame from "../createGame";
import MixPuzzleFailedScreen from "./MixPuzzle/pages/MixPuzzledFailedScreen";
import MixPuzzleGame from "./MixPuzzle/pages/MixPuzzleGame";
import { CompletedTodo } from "shared/todos/CompletedTodo";
import {
  ApiCompletedTodoCreateParams,
  apiCompletedTodoCreatePath,
  ApiCompletedTodoCreateResponse,
} from "apiRoutes/apiCompletedTodoRoutes";

export default createGame<GameQuestionMixPuzzle, GameAnswerMixPuzzle>({
  Game: MixPuzzleGame,
  FailureScreen: MixPuzzleFailedScreen,
  onSubmit: async (question, answer, auth) => {
    const { difficulty, mixPuzzle } = question;
    const pointsEarned = getMixPuzzlePoints({
      mixPuzzle,
      auth,
      difficulty,
      correct: answer.correct,
    });

    let completedTodos: CompletedTodo[] | null = null;

    if (question.todoId !== null && answer.correct) {
      const nextCompletedTodos = await api<
        ApiCompletedTodoCreateResponse,
        ApiCompletedTodoCreateParams
      >(apiCompletedTodoCreatePath, "POST", {
        body: { todo_id: question.todoId },
      });

      if (isSuccess(nextCompletedTodos)) {
        completedTodos = nextCompletedTodos.response;
      } else {
        alert("Something went wrong. Please try again later.");
      }
    }

    const user = await api<
      ApiPostMixPuzzleQuestionResponse,
      ApiPostMixPuzzleQuestionParams
    >(apiPostMixPuzzleQuestionPath, "POST", {
      body: {
        mix_puzzle_id: mixPuzzle.id,
        question: {
          correct: answer.correct,
          difficulty,
          points: pointsEarned,
        },
      },
    });

    if (!isSuccess(user)) {
      alert("Something went wrong. Please try again later.");
    }

    return {
      pointsEarned,
      user: isSuccess(user) ? user.response : null,
      completedTodos,
    };
  },
});
